import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import {
  Badge,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Divider,
  Form,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Table,
  Timeline,
} from "antd";
import styled from "styled-components";
import Text from "../../components/Text/Text";
import Input from "../../components/Input/Input";
import { roleDatasource } from "../../datasource/RoleDatasource";
import TextArea from "antd/es/input/TextArea";
import Button from "../../components/Button/Button";
import "./AdvanceCreditClass.css";
import { SequenceComponent } from "./SequenceComponent";
import { useEffectOnce } from "react-use";
import { NumberNotZero, onInputNumberKeyPress } from "../../utility/validator";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import {
  checkChangeLimitCredit,
  createAdvanceCreditSetting,
  getRuleById,
  getTeamInRule,
  updateAdvanceCreditSetting,
  updateShopWithNewCreditLimit,
} from "../../datasource/AdvanceCreditAppoveDatasource";
import { payloadTeam } from "../../entities/TeamEntity";
import { Tag } from "antd/lib";
import color from "../../resource/color";
import { CloseOutlined, WarningFilled } from "@ant-design/icons";
import { icon } from "../../resource";
import { ModalShopDetail, TagTeamComponent } from "./IndexAdvanceCreditSetting";
import { useMessageContext } from "../../context/MessageProvider";
import SortFieldCustom from "../../components/SortFieldTable/SortFieldCustom";
import { useTabState } from "../../hook/useTabState";

export const TimeLineStyled = styled(Timeline)`
  .ant-timeline-item-tail {
    border-inline-start: 2px dashed #8a93a8 !important;
  }
`;

export const CreateAdvanceCreditSetting: React.FC = () => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const { messageApi } = useMessageContext();
  const navigate = useNavigate();
  const ruleId = pathSplit[3];
  const isCreate = ruleId === "0";

  const [form] = Form.useForm();
  const [roleList, setRoleList] = useState<
    { label: string; value: string; key: string; count: number }[]
  >([]);
  const [teamList, setTeamList] = useState<{ label: string; value: string; key: string }[]>([]);
  const [countRole, setCountRole] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const watchTeam = Form.useWatch("teamId", form);
  const watchDeletedTeam = Form.useWatch("deletedTeam", form);
  const watchConditions = Form.useWatch("conditions", form);
  const watchLimitCreditPercent = Form.useWatch("limitCreditPercent", form);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [confirmExitModal, setConfirmExitModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<string[]>([]);
  const [deleteTeamModal, setDeleteTeamModal] = useState<{
    open: boolean;
    team: any;
  }>({
    open: false,
    team: null,
  });
  const [detailShopModal, setDetailShopModal] = useState<any>({
    open: false,
    teams: null,
    ruleName: "",
    ruleId: "",
  });
  const [shopCreditLimitModal, setShopCreditLimitModal] = useState<any>({
    open: false,
    shopList: null,
    ruleId: "",
    newLimitCreditPercent: undefined,
    dataUpdate: undefined,
  });

  useEffect(() => {
    if (watchConditions) {
      form.validateFields(["limitCreditPercent"]);
    }
  }, [watchConditions, form]);

  useEffectOnce(() => {
    if (ruleId === "0") {
      form.setFieldsValue({
        ruleName: undefined,
        ruleDescription: undefined,
        limitCreditPercent: undefined,
        statusRule: 2,
        statusLimitCredit: 2,
        teamId: [],
        conditions: [
          {
            groupNo: 1,
            min: 0,
          },
          // {
          //   groupNo: 2,
          //   min: undefined,
          // },
        ],
      });
    } else {
      fetchRuleDetail();
    }
    fetchRoles();
    fetchTeams();
  });

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  }, [loading, watchConditions]);

  const fetchRuleDetail = async () => {
    const ruleDetail = await getRuleById(ruleId);
    await form.setFieldsValue({
      ruleId: ruleDetail?.ruleId,
      ruleName: ruleDetail?.ruleName,
      ruleDescription: ruleDetail?.ruleDescription,
      limitCreditPercent: ruleDetail?.limitCreditPercent,
      statusRule: 2,
      statusLimitCredit: 2,
      conditions: ruleDetail?.conditions?.map((con: any) => {
        return {
          ...con,
          approvalList: con?.approvalList?.map((a: any) => ({
            ...a,
            firstname: a?.userStaff?.firstname,
            lastname: a?.userStaff?.lastname,
          })),
        };
      }),
      teamId: ruleDetail?.countCusComTeam?.map((t) => ({ ...t, shopCount: t.countUsed })),
    });
  };

  const fetchRoles = async () => {
    const res = await roleDatasource.getAllRoles({
      page: 1,
      take: 100,
      company: profile?.company,
    });
    setCountRole(res.data.count);
    setRoleList(
      res.data.data.map((role: any) => ({
        label: `${role.rolename} (${role.countmember} คน)`,
        value: role.rolename,
        key: role.roleId,
        disabled: role.countmember === 0,
        count: role.countmember,
      })),
    );
  };

  const fetchTeams = async () => {
    const payload: payloadTeam = {
      page: 0,
      take: 0,
      company: profile?.company,
      status: "ACTIVE",
    };
    const data = await getTeamInRule(profile?.company);
    const newFormat = (data || []).map((el: any) => {
      return {
        label: `${el.teamName}`,
        value: el.teamId,
        key: el.teamId,
        countNotUsed: el.countNotUsed,
        disabled: el.countUsed === el.total,
      };
    });
    setTeamList(newFormat);
  };

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={isCreate ? "สร้างกฎการอนุมัติ" : "แก้ไขกฎการอนุมัติ"}
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการกฎการอนุมัติ", path: "/order/advance-credit-limit" },
              {
                text: isCreate ? "สร้างกฎการอนุมัติ" : "แก้ไขกฎการอนุมัติ",
                path: window.location.pathname,
              },
            ]}
          />
        }
        onBack={() => setConfirmExitModal(true)}
      />
    );
  };

  const addGroup = () => {
    const conditions = form.getFieldsValue(true).conditions || [];
    const lastCondition = conditions[conditions.length - 1];
    setLoading(true);
    form.setFieldValue("conditions", [
      ...conditions,
      {
        groupNo: conditions.length + 1,
        min: lastCondition?.max || undefined,
        max: undefined,
        roleName: undefined,
        maximumApproval: undefined,
        approveType: undefined,
      },
    ]);
  };

  const onDeleteGroup = (groupNo: number) => {
    const newConditions = (form.getFieldsValue(true).conditions || []).filter(
      (c: any) => c.groupNo !== groupNo,
    );
    const limitCreditPercent = parseFloat(form.getFieldValue("limitCreditPercent"));
    const reorderedConditions = newConditions.map((c: any, index: number) => ({
      ...c,
      groupNo: index + 1,
      min: index === 0 ? 0 : newConditions[index - 1].max || undefined,
      max: limitCreditPercent
        ? newConditions.length === index + 1
          ? limitCreditPercent
          : c.max
        : c.max,
    }));
    form.resetFields(["conditions"]);
    form.setFieldValue("conditions", reorderedConditions);
  };

  const onDeleteTeam = async (teamId: string, dataFrom: any) => {
    const teamIdList = dataFrom.teamId || [];
    const deletedTeam = teamIdList.find((t: any) => t.teamId === teamId) || [];
    const newTeam = teamIdList.filter((t: any) => t.teamId !== teamId);
    const existingDeleted: any[] = form.getFieldValue("deletedTeam") || [];
    if (!deletedTeam) {
      return;
    }
    form.setFieldsValue({
      teamId: newTeam,
      deletedTeam: [...existingDeleted, deletedTeam],
    });
  };

  const onRestoreTeam = async (teamId: string, dataFrom: any) => {
    const deletedTeamList = dataFrom.deletedTeam || [];
    const restoreTeam = deletedTeamList.find((t: any) => t.teamId === teamId);
    const newDeletedTeam = deletedTeamList.filter((t: any) => t.teamId !== teamId);
    const existingTeam: any[] = form.getFieldValue("teamId") || [];
    if (!restoreTeam) {
      return;
    }
    form.setFieldsValue({
      teamId: [...existingTeam, restoreTeam],
      deletedTeam: newDeletedTeam,
    });
  };

  const updateRule = async (payload?: any) => {
    payload = {
      ...payload,
      countCusComTeam: payload.teamId,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };
    const res = await updateAdvanceCreditSetting(payload);
    return res.success;
  };

  const onSubmit = async () => {
    try {
      await form.validateFields();
      let payload: any = form.getFieldsValue(true);
      payload = {
        ...payload,
        conditions: payload.conditions.map((c: any) => ({
          ...c,
          maximumApproval: parseFloat(c.maximumApproval),
          min: String(c.min),
          max: parseFloat(c.max) ? String(c.max) : null,
          roleId: roleList.find((r) => r.value === c.roleName)?.key || null,
        })),
        createBy: profile?.firstname + " " + profile?.lastname,
        company: profile?.company,
        statusRule: payload.statusRule === 1 ? true : false,
        statusLimitCredit: payload.statusLimitCredit === 1 ? true : false,
      };

      if (payload.limitCreditPercent && !isCreate) {
        const shopList = await checkChangeLimitCredit({
          ruleId: ruleId,
          limitCreditPercent: payload.limitCreditPercent,
        }).then((res) => res);
        if (shopList?.length > 0) {
          setConfirmModal(false);
          setShopCreditLimitModal({
            open: true,
            shopList: shopList,
            ruleId: ruleId,
            newLimitCreditPercent: payload.limitCreditPercent,
            dataUpdate: payload,
          });
          return;
        }
      }

      if (isCreate) {
        const res = await createAdvanceCreditSetting(payload);
        if (res.success) {
          messageApi.success("บันทึกสำเร็จ");
          setConfirmModal(false);
          navigate("/order/advance-credit-limit");
        }
      } else {
        const success = await updateRule(payload);
        if (success) {
          messageApi.success("แก้ไขสำเร็จ");
          setConfirmModal(false);
          navigate("/order/advance-credit-limit");
        }
      }
    } catch (error) {
      setConfirmModal(false);
    }
  };

  return (
    <>
      <CardContainer>
        <div style={{ paddingBottom: "50px" }}>{PageTitle()}</div>
        <Form
          form={form}
          layout='vertical'
          initialValues={{ statusRule: false, statusLimitCredit: false }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label='ชื่อกฎการอนุมัติ'
                name='ruleName'
                rules={[{ required: true, message: "โปรดระบุชื่อกฎการอนุมัติ" }]}
                required
              >
                <Input placeholder='ระบุชื่อกฎการอนุมัติ' autoComplete='off' />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ paddingBottom: "8px" }}>
            <Col span={24}>
              <Form.Item label='คำอธิบาย (ถ้ามี)' name='ruleDescription'>
                <TextArea
                  placeholder='คำอธิบายโดยย่อของกฎข้อนี้'
                  autoComplete='off'
                  maxLength={150}
                  showCount
                />
              </Form.Item>
            </Col>
          </Row>
          <Card style={{ backgroundColor: "#FAFAFA" }}>
            <div style={{ paddingBottom: "10px" }}>
              <Text fontWeight={600}>ตั้งค่าเพิ่มเติม</Text> <Text>(ไม่บังคับ)</Text>
            </div>
            <Row justify={"space-between"} gutter={16}>
              <Col span={12}>
                {isCreate ? (
                  <>
                    <Form.Item label='ทีม' name='teamId'>
                      <Select
                        className='team-select'
                        placeholder='เลือกทีม'
                        showSearch={false}
                        mode='multiple'
                        options={teamList || []}
                        menuItemSelectedIcon={null}
                        onChange={setSelected}
                        allowClear
                        tagRender={({ value, closable, onClose }) => {
                          const option: any = teamList.find((x) => x.value === value);
                          return (
                            <Tag
                              closable={closable}
                              onClose={onClose}
                              color='#E5EAEE'
                              style={{ color: color.BK }}
                              closeIcon={
                                <CloseOutlined
                                  style={{
                                    color: color.BK,
                                    fontSize: 10,
                                  }}
                                />
                              }
                            >
                              <Text level={6}>
                                {option?.label}&nbsp;&nbsp;({option?.countNotUsed} ร้าน)
                              </Text>
                            </Tag>
                          );
                        }}
                        optionRender={(option: any) => {
                          return (
                            <Row justify={"space-between"}>
                              <Col>
                                <Checkbox
                                  checked={selected.includes(option.value)}
                                  disabled={option.data.disabled}
                                >
                                  {option.label}{" "}
                                  {!option.data.disabled &&
                                    `(${option.data.countNotUsed} ร้านที่ยังไม่มีกฎ)`}
                                </Checkbox>
                              </Col>
                              {option.data.disabled && (
                                <Col>
                                  <Text level={6} color='Text3'>
                                    ใช้กับกฎอื่นครบทุกร้านแล้ว
                                  </Text>
                                </Col>
                              )}
                            </Row>
                          );
                        }}
                      />
                    </Form.Item>
                    <Text level={6} color='Text3'>
                      หากบันทึกแล้ว ทุกร้านในทีมจะถูกผูกเข้ากับกฎนี้ทันที
                    </Text>
                  </>
                ) : (
                  <>
                    <div>ทีมที่ใช้อยู่ในกฎนี้</div>
                    {form.getFieldValue("teamId")?.length === 0 ? (
                      <Input placeholder='ไม่มีทีมในกฎ' style={{ color: color.BK }} disabled />
                    ) : (
                      <Card
                        style={{ backgroundColor: "#F3F6F9" }}
                        bodyStyle={{
                          paddingTop: "7px",
                          paddingBottom: "7px",
                          paddingLeft: "5px",
                        }}
                      >
                        {form.getFieldValue("teamId")?.map((team: any) => (
                          <Row style={{ padding: "5px" }} key={team.teamId}>
                            <div
                              onClick={() =>
                                setDetailShopModal({
                                  open: true,
                                  teams: form.getFieldValue("teamId"),
                                  ruleName: form.getFieldValue("ruleName"),
                                  ruleId: form.getFieldValue("ruleId"),
                                })
                              }
                            >
                              <TagTeamComponent team={team} />
                            </div>{" "}
                            <Text
                              level={6}
                              color='primary'
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setDeleteTeamModal({
                                  open: true,
                                  team: team,
                                });
                              }}
                            >
                              ลบออก
                            </Text>
                          </Row>
                        ))}
                      </Card>
                    )}
                  </>
                )}
              </Col>
              <Col span={12}>
                <Form.Item
                  label='% เพดานวงเงินเกินเริ่มต้น (ค่า Default ของกฎนี้)'
                  name='limitCreditPercent'
                  rules={[
                    {
                      validator: (_, value) => {
                        if (
                          value &&
                          Array.isArray(watchConditions) &&
                          watchConditions.length > 0 &&
                          watchConditions.some((s) => s && s.max !== undefined)
                        ) {
                          const maxValues = watchConditions
                            .map((s) => parseFloat(s?.max))
                            .filter((v) => !isNaN(v));
                          if (maxValues.length > 0 && parseFloat(value) < Math.max(...maxValues)) {
                            return Promise.reject(
                              new Error("เพดานต้องสูงกว่า วงเงินเกินสูงสุด (Max) ของทุกลำดับ"),
                            );
                          } else if (parseFloat(value) <= 0) {
                            return Promise.reject(new Error("% เพดานต้องมากกว่า 0"));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุ % เพดานวงเงินเกิน'
                    autoComplete='off'
                    suffix='%'
                    onKeyDown={onInputNumberKeyPress}
                    onChange={(e) => {
                      if (!e.target.value) {
                        form.setFieldValue("statusLimitCredit", 2);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            {form?.getFieldValue("deletedTeam")?.length > 0 && (
              <Row>
                <Col span={12}>
                  <div>ทีมที่ต้องการลบออก</div>
                  <Form.Item name={"deletedTeam"}>
                    <Card
                      style={{ backgroundColor: "#F3F6F9" }}
                      bodyStyle={{
                        paddingTop: "7px",
                        paddingBottom: "7px",
                        paddingLeft: "5px",
                      }}
                    >
                      {form?.getFieldValue("deletedTeam")?.map((team: any) => (
                        <div style={{ padding: "5px" }} key={team.teamId}>
                          <Row>
                            <div
                              onClick={() =>
                                setDetailShopModal({
                                  open: true,
                                  teams: form.getFieldValue("deletedTeam"),
                                  ruleName: form.getFieldValue("ruleName"),
                                  ruleId: form.getFieldValue("ruleId"),
                                })
                              }
                            >
                              <TagTeamComponent team={team} />
                            </div>{" "}
                            <Text
                              level={6}
                              color='primary'
                              style={{ cursor: "pointer" }}
                              onClick={() => onRestoreTeam(team.teamId, form.getFieldsValue(true))}
                            >
                              เพิ่มกลับเข้ากฎ
                            </Text>
                          </Row>
                        </div>
                      ))}
                    </Card>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {watchTeam?.length > 0 && (
              <Card
                style={{ border: "none", backgroundColor: "#F3F6F9" }}
                bodyStyle={{ paddingBottom: "5px" }}
              >
                <div style={{ paddingBottom: "10px" }}>
                  <Text level={5} fontWeight={600}>
                    หลังสร้างกฎนี้สำเร็จ
                  </Text>
                </div>
                <Row justify={"space-between"}>
                  <Col span={12}>
                    <Form.Item label='เปิดสั่งวงเงินเกินให้ร้านค้าทันที' name='statusRule'>
                      <Radio.Group
                        defaultValue={form.getFieldValue("statusRule")}
                        options={[
                          { value: 1, label: "เปิดใช้งาน" },
                          { value: 2, label: "ปิดใช้งาน" },
                        ]}
                        onChange={(e: any) => {
                          const checked = `${e.target.value === 2}`;
                          if (checked) {
                            form.setFieldValue("statusLimitCredit", 2);
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label='เปิดเพดานวงเงินเกินให้ร้านค้าทันที' name='statusLimitCredit'>
                      <Radio.Group
                        defaultValue={form.getFieldValue("statusLimitCredit")}
                        options={[
                          { value: 1, label: "เปิดใช้งาน" },
                          { value: 2, label: "ปิดใช้งาน" },
                        ]}
                        onChange={(e: any) => {
                          const checked = `${e.target.value === 1}`;
                          if (checked) {
                            form.setFieldValue("statusRule", 1);
                          }
                        }}
                        disabled={!watchLimitCreditPercent}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            )}
          </Card>
          <br />
          <Row justify={"space-between"}>
            <Col style={{ paddingTop: "15px" }}>
              <Text fontWeight={600} level={5}>
                ลำดับการอนุมัติ (ขั้นบันได)
              </Text>
            </Col>
            <Col>
              <Button
                typeButton={
                  (form.getFieldsValue(true)?.conditions || []).length >= countRole
                    ? "disabled"
                    : "primary-light"
                }
                title='+ เพิ่มลำดับ'
                size='small'
                onClick={() =>
                  (form.getFieldsValue(true)?.conditions || []).length < countRole && addGroup()
                }
                disabled={(form.getFieldsValue(true)?.conditions || []).length >= countRole}
              />
            </Col>
          </Row>
          <br />
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <Spin size='large' />
            </div>
          ) : (
            <>
              <TimeLineStyled
                mode='left'
                items={(form?.getFieldsValue(true)?.conditions || [])?.map((item, index) => ({
                  dot: (
                    <Badge
                      key={item.groupNo}
                      count={item.groupNo}
                      color='#1B4586'
                      style={{
                        width: 25,
                        height: 25,
                        lineHeight: "25px",
                        borderRadius: "50%",
                        fontSize: 16,
                      }}
                    />
                  ),
                  color: index === 0 ? "green" : "blue",
                  children: (
                    <SequenceComponent
                      key={item.groupNo}
                      groupNo={item.groupNo}
                      index={index}
                      form={form}
                      roleList={roleList}
                      onDeleteGroup={onDeleteGroup}
                      isEdit={!isCreate}
                    />
                  ),
                }))}
              />
            </>
          )}
        </Form>
        <Row justify='end'>
          <Col span={3}>
            <Button typeButton='primary' title='บันทึก' onClick={() => setConfirmModal(true)} />
          </Col>
        </Row>
      </CardContainer>
      {confirmModal && (
        <ConfirmModal
          visible={confirmModal}
          //loading={submitting}
          onConfirm={() => {
            onSubmit();
          }}
          onCancel={() => {
            setConfirmModal(false);
          }}
          title={isCreate ? "บันทึกสร้างกฎการอนุมัติ" : "ยืนยันบันทึกการแก้ไขกฎ"}
          desc={
            isCreate
              ? "โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน"
              : "โปรดตรวจสอบรายละเอียดอีกครั้งก่อนกดยืนยัน เพราะอาจส่งผลต่อการแสดงผลการอนุมัติวงเงินเกินในระบบ"
          }
        />
      )}
      {confirmExitModal && (
        <Modal
          open={confirmExitModal}
          onCancel={() => setConfirmExitModal(false)}
          footer={null}
          centered
          title={
            <Text level={3} fontWeight={600}>
              ยังมีข้อมูลที่ยังไม่ได้บันทึก
            </Text>
          }
        >
          <Text color='Text3'>
            โปรดตรวจสอบรายละเอียดอีกครั้ง <br /> เพราะมีผลกับข้อมูลกฎที่กำลังดำเนินการ?
          </Text>
          <Button
            typeButton='primary'
            title='ยืนยันการบันทึก'
            onClick={() => {
              setConfirmExitModal(false);
              onSubmit();
            }}
            style={{ marginTop: "5px" }}
          />
          <Button
            typeButton='primary-light'
            title='แก้ไขต่อ'
            onClick={() => {
              setConfirmExitModal(false);
            }}
            style={{ marginTop: "5px" }}
          />
          <Button
            typeButton='border-danger'
            title='ออกโดยไม่บันทึก'
            onClick={() => {
              setConfirmExitModal(false);
              navigate(-1);
            }}
            style={{ marginTop: "5px" }}
          />
        </Modal>
      )}
      {deleteTeamModal.open && (
        <Modal
          open={deleteTeamModal.open}
          closable={false}
          onCancel={() => setDeleteTeamModal({ open: false, team: null })}
          centered
          title={
            <Text level={3} fontWeight={600}>
              {`ต้องการลบทีม "${deleteTeamModal.team?.teamName}" ออกจากกฎนี้`}
            </Text>
          }
          okText='ลบทีม'
          okButtonProps={{ danger: true }}
          cancelText='ยกเลิก'
          onOk={() => {
            onDeleteTeam(deleteTeamModal?.team?.teamId, form.getFieldsValue(true));
            setDeleteTeamModal({ open: false, team: null });
          }}
        >
          <Text color='error' fontWeight={600}>
            ร้านค้า {deleteTeamModal.team?.countAll} ร้านที่ทีมนี้ดูแลอยู่จะถูกนำออกจากกฎพร้อมกัน
          </Text>
          <br />
          <Text color='error'>หลังบันทึกกฎ ร้านค้าเหล่านี้จะไม่สามารถสั่งซื้อวงเงินเกินได้</Text>
          <br />
          <Text color='error'>จนกว่าจะถูกเพิ่มเข้ากฎการอนุมัติอื่น</Text>
        </Modal>
      )}
      {detailShopModal.open && (
        <ModalShopDetail
          detailShopModal={detailShopModal}
          setDetailShopModal={setDetailShopModal}
        />
      )}
      {shopCreditLimitModal.open && (
        <ModalShopOverCreditLimit
          shopCreditLimitModal={shopCreditLimitModal}
          setShopCreditLimitModal={setShopCreditLimitModal}
          onUpdate={updateRule}
        />
      )}
    </>
  );
};

export const ModalShopOverCreditLimit: React.FC<{
  shopCreditLimitModal: any;
  setShopCreditLimitModal: any;
  onUpdate?: any;
}> = ({ shopCreditLimitModal, setShopCreditLimitModal, onUpdate }) => {
  const { messageApi } = useMessageContext();
  const navigate = useNavigate();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [data, setData] = useState<any>(shopCreditLimitModal.shopList || []);
  const orderTabState = useTabState();

  useEffect(() => {
    const sortedData = orderTabState.sortDirection
      ? [...data].sort((a, b) => {
          const field = orderTabState.sortField;
          const direction = orderTabState.sortDirection === "ASC" ? 1 : -1;
          if (a[field] < b[field]) return -1 * direction;
          if (a[field] > b[field]) return 1 * direction;
          return 0;
        })
      : shopCreditLimitModal.shopList;
    setData(sortedData);
  }, [orderTabState.sortField, orderTabState.sortDirection]);

  const columes = [
    {
      title: (
        <SortFieldCustom
          title='รหัสร้านค้า'
          sortDirection={
            orderTabState.sortField === "customerNo" ? orderTabState.sortDirection : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("customerNo")}
        />
      ),
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, record: any) => {
        return <Text>{value}</Text>;
      },
    },
    {
      title: (
        <SortFieldCustom
          title='ชื่อร้านค้า'
          sortDirection={
            orderTabState.sortField === "customerName" ? orderTabState.sortDirection : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("customerName")}
        />
      ),
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, record: any) => {
        return (
          <>
            <Text>{value}</Text>
          </>
        );
      },
    },
    {
      title: (
        <SortFieldCustom
          title='เขต'
          sortDirection={
            orderTabState.sortField === "zone" ? orderTabState.sortDirection : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("zone")}
        />
      ),
      dataIndex: "zone",
      key: "zone",
      render: (value: any, record: any) => {
        return (
          <>
            <Text>{value}</Text>
          </>
        );
      },
    },
    {
      title: (
        <SortFieldCustom
          title='% เพดาน'
          sortDirection={
            orderTabState.sortField === "customLimitCreditPercent"
              ? orderTabState.sortDirection
              : undefined
          }
          onSortChange={() => orderTabState.handleSortChange("customLimitCreditPercent")}
        />
      ),
      dataIndex: "customLimitCreditPercent",
      key: "customLimitCreditPercent",
      width: "15%",
      render: (value: any, record: any) => {
        return (
          <>
            <Text color='warning' fontWeight={600}>
              {value}%
            </Text>
          </>
        );
      },
    },
  ];

  const onConfirm = async () => {
    const success = await onUpdate(shopCreditLimitModal.dataUpdate);
    if (success) {
      const payload = {
        customerCompanyIds: shopCreditLimitModal.shopList?.map((s: any) =>
          Number(s.customerCompanyId),
        ),
        ruleId: shopCreditLimitModal.ruleId,
        updateBy: profile.firstname + " " + profile?.lastname,
      };
      await updateShopWithNewCreditLimit(payload).then((res) => {
        if (res.success) {
          setShopCreditLimitModal({ open: false, shopList: null, ruleId: "" });
          messageApi.success("บันทึกสำเร็จ");
          navigate("/order/advance-credit-limit");
        }
      });
    }
  };

  return (
    <Modal
      open={shopCreditLimitModal.open}
      maskClosable={false}
      onCancel={() => setShopCreditLimitModal({ open: false, shopList: null, ruleId: "" })}
      centered
      width={800}
      cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
      okText='ยืนยันการเปลี่ยนแปลง'
      onOk={() => {
        onConfirm();
      }}
    >
      <Row justify='start' gutter={8}>
        <Col>
          <WarningFilled style={{ color: color.warning, fontSize: "24px" }} />
        </Col>
        <Col>
          <Text fontWeight={600} level={4}>
            พบ {shopCreditLimitModal.shopList?.length || 0}{" "}
            ร้านค้าที่ปรับแต่งค่าเพดานวงเงินเกินสูงกว่าเพดานใหม่ (
            {shopCreditLimitModal.newLimitCreditPercent}%)
          </Text>
        </Col>
      </Row>
      <br />
      <Text>
        กรุณาตรวจสอบรายชื่อร้านค้าด้านล่าง หากยืนยันการเปลี่ยนแปลง
        ระบบจะปรับเพดานวงเงินเกินของกฎนี้เป็น {shopCreditLimitModal.newLimitCreditPercent}%
        และรีเซ็ตการตั้งค่าของร้านค้าในรายการให้เป็นแบบเดียวกับกฎนี้ (จากสถานะ “ปรับแต่ง” เป็น
        “ค่าเริ่มต้น”)
      </Text>
      <Divider size='small' />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
            },
          },
        }}
      >
        <Table
          columns={columes}
          dataSource={data || []}
          size='small'
          pagination={false}
          scroll={{ x: "max-content", y: 360 }}
        />
      </ConfigProvider>
    </Modal>
  );
};
